function isRecord(value) {
    return 'object' == typeof value && null !== value;
}
function resolveEmbeddedEntryContentType(target) {
    if (!isRecord(target)) return;
    const sys = isRecord(target.sys) ? target.sys : void 0;
    const contentType = sys && isRecord(sys.contentType) ? sys.contentType : void 0;
    const contentTypeSys = contentType && isRecord(contentType.sys) ? contentType.sys : void 0;
    const id = contentTypeSys?.id;
    return 'string' == typeof id ? id : void 0;
}
const defaultEmbeddedEntryRegistry = {};
function mergeEmbeddedEntryRegistry(overrides) {
    if (!overrides) return defaultEmbeddedEntryRegistry;
    return {
        ...defaultEmbeddedEntryRegistry,
        ...overrides
    };
}
export { defaultEmbeddedEntryRegistry, mergeEmbeddedEntryRegistry, resolveEmbeddedEntryContentType };
